import api from "./api";

export type LeaveType = "sick" | "annual" | "casual" | "maternity" | "paternity";

export interface LeaveSettingsPayload {
  sick_days: number;
  annual_days: number;
  casual_days: number;
  maternity_enabled: boolean;
  maternity_days: number;
  paternity_enabled: boolean;
  paternity_days: number;
  year_start_month: number; // 1..12
}

export interface LeaveSettings extends LeaveSettingsPayload {
  id: string;
  branchID: string | null;
  headOfficeID: string | null;
  masterID: string | null;
  updated_at?: string | null;
  updated_by?: string | null;
}

export interface LeaveBalanceEntry {
  allocated: number;
  used: number;
  reserved_pending: number;
  remaining: number;   // displayed: opening - used (past-approved only)
  available: number;   // for validation: opening - used - reserved_pending
}

export interface LeaveBalance {
  leave_year: { label: number; start: string; end: string };
  balances: Partial<Record<LeaveType, LeaveBalanceEntry>>;
  employee?: { id: string; name: string };
}

export const getLeaveSettings = async (): Promise<LeaveSettings> => {
  const res = await api.get("/salary/leave_settings");
  return res.data?.data;
};

export const updateLeaveSettings = async (
  payload: LeaveSettingsPayload
): Promise<{
  data: LeaveSettings;
  ledger_rows_updated: number;
  employees_affected: number;
}> => {
  const res = await api.put("/salary/leave_settings", payload);
  return {
    data: res.data?.data,
    ledger_rows_updated: res.data?.ledger_rows_updated || 0,
    employees_affected: res.data?.employees_affected || 0,
  };
};

export const getLeaveBalance = async (
  empId?: string
): Promise<LeaveBalance> => {
  const path = empId ? `/salary/leave_balance/${empId}` : "/salary/leave_balance";
  const res = await api.get(path);
  return res.data?.data;
};
